import i18n from '../i18n';
import type { SnackbarProps } from '@mui/material';

/** Clave i18n del mensaje estándar de restricción demo. */
export const DEMO_RESTRICTION_SNACKBAR = 'permissions.demoRestriction';

export const getDemoRestrictionMessage = () => (i18n as any).t(DEMO_RESTRICTION_SNACKBAR);

// Mantener compatibilidad con código existente - ahora es una función que se evalúa cuando se necesita
export const DEMO_RESTRICTION_MESSAGE = getDemoRestrictionMessage();

export type DemoRestrictionHandler = (message?: string) => void;

/** Posición estándar: arriba, por encima de la barra de navegación inferior (z-index 1400). */
export const DEMO_RESTRICTION_SNACKBAR_ANCHOR = { vertical: 'top', horizontal: 'center' } as const;

export const DEMO_RESTRICTION_SNACKBAR_SX = {
  top: '16px !important',
  maxWidth: 'calc(100vw - 32px)',
  zIndex: 1900,
};

export const DEMO_RESTRICTION_SNACKBAR_SX_WITH_HEADER = {
  top: '56px !important',
  maxWidth: 'calc(100vw - 32px)',
  zIndex: 1900,
};

/** Props de layout para Snackbars que muestran restricciones demo (u otros mensajes del mismo canal). */
export const getDemoRestrictionSnackbarProps = (
  options?: { withHeader?: boolean; sx?: SnackbarProps['sx'] },
): Pick<SnackbarProps, 'anchorOrigin' | 'sx'> => ({
  anchorOrigin: DEMO_RESTRICTION_SNACKBAR_ANCHOR,
  sx: {
    ...(options?.withHeader ? DEMO_RESTRICTION_SNACKBAR_SX_WITH_HEADER : DEMO_RESTRICTION_SNACKBAR_SX),
    ...(typeof options?.sx === 'object' && options.sx !== null ? options.sx : {}),
  },
});

export const notifyDemoRestriction = (
  setSnackbar: (snackbar: { open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }) => void
) => {
  setSnackbar({
    open: true,
    message: (i18n as any).t(DEMO_RESTRICTION_SNACKBAR),
    severity: 'error'
  });
};
